/**
 * @file 外部链接配置文件
 * @description 统一管理项目中所有外部链接，避免硬编码
 * @author 智慧云行
 * @date 2025-12-16
 */

export default {
  // ============================================
  // 操作手册/使用手册
  // ============================================
  manual: {
    // 定制客运/顺风车/场站 使用手册
    default: 'https://www.yuque.com/books/share/e746086a-47ed-4375-a144-b833c8af4a17?#',
    // 客运站 使用手册
    station: 'https://www.yuque.com/palowlto/go27df?#'
  },

  // ============================================
  // 更新日志
  // ============================================
  changelog: 'https://www.yuque.com/shunfengxia/cngfe3',

  // ============================================
  // 第三方服务
  // ============================================
  services: {
    // 短信充值平台
    smsRecharge: 'https://manage.rvaka.com/#/recharge',
    // AI识别充值平台
    aiRecharge: 'https://manage.rvaka.com/#/recharge'
  },

  // ============================================
  // 帮助文档
  // ============================================
  docs: {
    // Banner跳转类型说明文档
    bannerJumpType: 'https://www.yuque.com/daixiaoming-eoqvp/udgkrz/vp33uoc6ccrm0tzn?singleDoc#',
    // 顺风车司机审核说明文档
    driverAudit: 'https://hjjuko8dme.feishu.cn/docx/Bqa9dANJYo6HyjxYwfFcRhodnNb?from=from_copylink'
  },

  // ============================================
  // 公司信息
  // ============================================
  company: {
    name: '智慧云行（成都）科技有限公司',
    appTitle: '顺风侠城际出行平台',
    website: 'https://www.zhihuiyunxing.com',
    email: 'service@zhihuiyunxing.com',
    phone: '4000490016',
    address: '四川省成都市武侯区智星三路331号1层',
    icp: '蜀ICP备2020030731号-3',
    foundedDate: '2020年7月23日',
    creditCode: '91510115MA6BL9J08M'
  },

  // ============================================
  // 资源域名
  // ============================================
  resources: {
    // 七牛云图片域名
    qiniuDomain: 'https://busimg.zhihuiyunxing.com/',
    // Favicon
    favicon: 'https://busimg.zhihuiyunxing.com/logo.png'
  },

  // ============================================
  // 登录页面配置
  // ============================================
  login: {
    // 文本配置
    texts: {
      loading: '正在加载',
      phonePlaceholder: '请输入账户名/手机号',
      passwordPlaceholder: '请输入密码',
      passwordToggleTitle: '显示/隐藏密码',
      rememberPassword: '记住账号密码',
      agreementPrefix: '我已阅读并同意',
      userAgreement: '《服务协议》',
      privacyPolicy: '《隐私政策》',
      and: '和',
      loginButton: '立即登录',
      selectPlatformTitle: '选择登录平台',
      selectPlatformTip: '您的账号均是以下平台成员，请选择要登录的平台',
      accountDisabled: '账号停用，无法登录',
      passwordCorrect: '密码正确，点击登录',
      passwordIncorrect: '密码错误，无法登录',
      arrearsPrefix: '系统因欠费',
      arrearsSuffix: '已被暂停使用，请尽快完成续费',
      billDetail: '账单明细：',
      renewButton: '立即续费',
      renewTitle: '续费',
      qrcodeHint: '请使用 支付宝 扫码充值',
      loginSuccess: '登录成功，正在跳转...',
      systemSuspended: '系统已被暂停使用',
      systemArrears: '系统已欠费',
      rechargeSuccess: '充值成功，请重新登录',
      qrcodeExpired: '二维码失效，请重新充值',
      agreementWarning: '请先阅读并同意服务协议和隐私政策'
    },
    // 验证配置
    validation: {
      phoneMaxLength: 11,
      passwordMaxLength: 20,
      passwordMinLength: 6,
      phoneEmptyError: '请输入账户名或手机号',
      phoneFormatError: '手机号格式不正确',
      passwordEmptyError: '请输入密码',
      passwordLengthError: '密码长度不能少于6位'
    },
    // 动画配置
    animation: {
      particleCount: 50,
      shakeDelay: 500,
      redirectDelay: 600
    },
    // 二维码配置
    qrcode: {
      size: 200,
      timeout: 120,
      pollInterval: 3000,
      pollIncrement: 3
    },
    // 权限配置
    permissions: {
      workbenchId: 36
    },
    // 路由配置
    routes: {
      workbench: '/workbench',
      frame: '/frame'
    },
    // 表格列配置
    billColumns: [
      { prop: 'time', label: '对账日期', width: 200 },
      { prop: 'finishOrderNum', label: '完成订单' },
      { prop: 'totalRealFee', label: '成交金额(GMV)' },
      { prop: 'ratio', label: '佣金比例' },
      { prop: 'serviceFee', label: '应付服务费' }
    ]
  },

  // ============================================
  // 车主审核拒绝理由配置
  // ============================================
  auditRejectReasons: {
    // 顺风车拒绝理由
    sfx: [
      { label: '证件模糊：身份证照片模糊，请重新拍摄清晰、无反光、四角完整的证件照片' },
      { label: '证件模糊：行驶证照片模糊，请提供正本与副本高清图，避免裁剪或信息缺失' },
      { label: '证件模糊：驾驶证照片模糊，请上传完整页面（含正、副页），确保文字及印章清晰可辨' },
      { label: '信息不匹配：行驶证所有人与注册人姓名不一致（需确保为同一人）' },
      { label: '信息不匹配：行驶证信息与注册车辆不符（如车辆号牌、车架号不一致）' },
      { label: '信息不匹配：驾驶证信息与证件照片不符（如准驾车型、有效期异常）' },
      { label: '信息不匹配：身份证信息与证件照片不一致（如姓名、号码或出生日期不符）' },
      { label: '未上传交强险保单，请提交完整且有效的交强险保单' },
      { label: '未上传商业险保单，请提交完整且有效的商业险保单' },
      { label: '上传文件非交强险/商业险保单（如其他无关证件或图片），请重新提交真实有效的保单材料' },
      { label: '交强险/商业险保单中车辆信息（车辆号牌、车架号）与注册车辆不一致' },
      { label: '交强险/商业险保单照片不完整，请上传全部有效页面（含投保公司、有效期及车辆信息）' },
      { label: '交强险/商业险保单投保有效期已失效，请重新上传有效期内的完整保单' },
      { label: '车辆资质问题：车辆为租赁公司所有且无运营资质，不符合顺风车注册要求' },
      { label: '车辆照片拍摄角度与清晰度不达标：请上传车辆正面45度（左前或右前视角）完整高清照片，确保车辆号牌码、车身整体及外观细节清晰可见，避免遮挡、反光或阴影覆盖关键区域' },
      { label: '其他' }
    ],
    // 场站/定制客运拒绝理由
    cz: [
      { label: '身份证照片模糊，请重新拍摄清晰完整的证件照片' },
      { label: '驾驶证照片模糊，请重新拍摄清晰完整的证件照片' },
      { label: '行驶证照片模糊，请重新拍摄清晰完整的证件照片' },
      { label: '身份证信息与证件照片不符合' },
      { label: '驾驶证信息与证件照片不符合' },
      { label: '行驶证信息与证件照片不符合' },
      { label: '其他' }
    ]
  }
}

/**
 * 根据平台类型获取使用手册链接
 * @param {number} platformType - 平台类型 (1:定制客运, 2:客运站, 3:顺风车, 4:场站)
 * @returns {string} 使用手册链接
 */
export function getManualUrl(platformType) {
  const links = {
    1: 'https://www.yuque.com/books/share/e746086a-47ed-4375-a144-b833c8af4a17?#', // 定制客运
    2: 'https://www.yuque.com/palowlto/go27df?#', // 客运站
    3: 'https://www.yuque.com/books/share/e746086a-47ed-4375-a144-b833c8af4a17?#', // 顺风车
    4: 'https://www.yuque.com/books/share/e746086a-47ed-4375-a144-b833c8af4a17?#'  // 场站
  }
  return links[platformType] || links[1]
}

/**
 * 获取充值链接
 * @param {string} type - 充值类型 ('sms' | 'ai')
 * @param {number} companyId - 公司ID
 * @param {string} token - 授权token
 * @returns {string} 充值链接
 */
export function getRechargeUrl(type, companyId, token) {
  const baseUrl = 'https://manage.rvaka.com/#/recharge'
  const rechargeType = type === 'ai' ? 'busAi' : 'sms'
  return `${baseUrl}?companyId=${companyId}&rechargeSource=passengerTransport&type=${rechargeType}&authorization=${token}`
}
